/**
 * Created by rickborst on 25/04/2017.
 */

import _ from 'lodash';

import Image from 'models/image';
import PlaybackRules from 'models/playbackrules';
import Media from './asset/media';
import MatchInfo from './asset/matchinfo';

const BroadcastTypes = {
        LIVE: 'LIVE',
        CATCH_UP: 'CATCH_UP',
        REGULAR: 'REGULAR'
    },

    ProgramTypes = {
        MATCH: 'MATCH',
        SHOW: 'SHOW',
        NEWS: 'NEWS',
        DOCUMENTARY: 'DOCUMENTARY',
        ORIGINAL: 'ORIGINAL',
        MAGAZINE: 'MAGAZINE',
        RECAP: 'RECAP',
        UNKNOWN: 'UNKNOWN'
    },

    AssetTypes = {
        EPG_ITEM: 'EPG_ITEM',
        LINEAR: 'LINEAR',
        MOVIE: 'MOVIE',
        EPISODE: 'EPISODE',
        SERIES: 'SERIES',
        LEAGUE: 'LEAGUE',
        TEAM: 'TEAM',
        SPORT: 'SPORT',
        UNKNOWN: 'UNKNOWN'
    };

class Asset {

    constructor (options = {}) {
        this.id = options.id || '';
        this.title = options.title || '';
        this.subTitle = options.subTitle || '';
        this.description = options.description || '';
        this.episodeNumber = options.episodeNumber || '';
        this.seriesId = options.seriesId || '';
        this.seriesName = options.seriesName || '';
        this.type = options.type || '';
        this.images = _.map(options.images || [], data => {
            return new Image(data);
        });
        this.media = _.map(options.media || [], data => {
            return new Media(data);
        });
        this.start = options.start || '';
        this.end = options.end || '';
        this.matchInfo = new MatchInfo(options.matchInfo || {});
        this.programType = options.programType || '';
        this.broadcastType = options.broadcastType || '';
        this.tags = options.tags || {};
        this.rating = options.rating || '';
        this.playbackRules = new PlaybackRules(options.playbackRules || {});
        this.apiSpecifics = options.apiSpecifics || {};
        this.query = null || options.query;
        this.reminder = options.reminder || null;

        return this;
    }

    /**
     * Sets assets reminder.
     *
     * @param {Object} reminder - Sets reminder.
     */
    setReminder (reminder) {
        this.reminder = reminder;
    }
}

export {
    BroadcastTypes,
    ProgramTypes,
    AssetTypes
};
export default Asset;


// WEBPACK FOOTER //
// ./src/js/models/asset.js